import { IDs } from '../../helpers/IDs';

export function getValidDataEntitiesMap(data: any, standort: number): any {
    data = data || {};
    const kennzahlen: any = (data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort] || data[IDs.KENNZIFFERN_BERECHNET] || {};
    const flags: any = kennzahlen.flags || {};

    return {
        [IDs.ENT_BETRIEBSDATEN]: !!flags.hasBetriebsdaten,
        [IDs.ENT_ENERGIEDATEN_EIGENSTROM]: !!flags.hasStrom && !!flags.hasEigenstrom,
        [IDs.ENT_ENERGIEDATEN_EIGENWAERME]: !!flags.hasWaerme,
        [IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE]: !!flags.hasKraftstoffe,
        [IDs.ENT_ENERGIEDATEN_STROM]: !!flags.hasStrom,
        [IDs.ENT_ENERGIEDATEN_WAERME]: !!flags.hasWaerme,
        [IDs.ENT_ENERGIEDATEN_WASSER]: !!flags.hasWasser,
        [IDs.ENT_KENNZIFFERN_GENERATED]: !!flags.hasKraftstoffe && !!flags.hasStrom && !!flags.hasWaerme,
        [IDs.ENT_SONSTIGE_DATEN]: !!flags.hasBetriebsdaten
    };
}
